module.exports = __webpack_public_path__ + "img/03-channels-icon.ebf18d93.svg";